// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23e0e0e0%27%3E%3Cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body.dark-only {
  background-color: #1e1e2e !important;
}
body.dark-only .page-body-wrapper,
body.dark-only .page-body,
body.dark-only .container-fluid {
  background-color: #1e1e2e !important;
}
body.dark-only .table-ad {
  border: 1px solid #009db5 !important;
  border-radius: 4px;
  background-color: #1e1e2e !important;
}
body.dark-only .MuiPaper-root,
body.dark-only .MuiDialog-paper,
body.dark-only .MuiTableContainer-root,
body.dark-only .MuiTable-root,
body.dark-only .MuiPaper-elevation,
body.dark-only .MuiPaper-rounded,
body.dark-only .MuiPaper-elevation2,
body.dark-only .table-ad,
body.dark-only .table-ad__wrapper,
body.dark-only .table-ad__wrapperCard,
body.dark-only .tablePaperPosition {
  background-color: #1e1e2e !important;
  color: #e0e0e0 !important;
}
body.dark-only .table-ad__wrapperCard .table-ad__bg-reset {
  background-color: transparent !important;
  color: #e0e0e0 !important;
}
body.dark-only .table-ad__wrapperCard {
  border: 1px solid #009db5 !important;
}
body.dark-only .MuiTableHead-root .MuiTableCell-root,
body.dark-only .MuiTableHead-root th,
body.dark-only .MuiTableCell-stickyHeader,
body.dark-only .MuiTableHead-root th[data-pinned=true] {
  background-color: #16213e !important;
  color: #e0e0e0 !important;
  border-bottom: 1px solid #2e2e42 !important;
}
body.dark-only .MuiTableHead-root .MuiTableSortLabel-icon,
body.dark-only .MuiTableHead-root .MuiTableSortLabel-root svg,
body.dark-only .MuiTableHead-root .Mui-TableHeadCell-Content-Actions svg,
body.dark-only .MuiTableHead-root .Mui-TableHeadCell-Content-Labels svg {
  color: #e0e0e0 !important;
  fill: #e0e0e0 !important;
  opacity: 0.4 !important;
}
body.dark-only .MuiTableHead-root .MuiTableSortLabel-root.Mui-active .MuiTableSortLabel-icon {
  opacity: 1 !important;
  color: #009db5 !important;
  fill: #009db5 !important;
}
body.dark-only .MuiTableBody-root .MuiTableCell-root,
body.dark-only .MuiTableBody-root td,
body.dark-only td[data-pinned=true],
body.dark-only .MuiTableBody-root .MuiTableRow-root .MuiTableCell-root:first-of-type {
  background-color: #1e1e2e !important;
  color: #ccc !important;
  border-bottom: 1px solid #2e2e42 !important;
}
body.dark-only .MuiTableBody-root .MuiTableRow-root:nth-of-type(even) td {
  background-color: #22223a !important;
}
body.dark-only .MuiTableRow-root:hover td,
body.dark-only .MuiTableBody-root .MuiTableRow-root:hover .MuiTableCell-root {
  background-color: #2a2a3e !important;
  cursor: pointer;
}
body.dark-only th[data-pinned=true],
body.dark-only .MuiTableCell-root[data-pinned=true] {
  background-color: #1e1e2e !important;
  color: #e0e0e0 !important;
  box-shadow: none !important;
}
body.dark-only td[data-pinned=true]::after, body.dark-only td[data-pinned=true]::before,
body.dark-only th[data-pinned=true]::after, body.dark-only th[data-pinned=true]::before {
  background: transparent !important;
  box-shadow: none !important;
}
body.dark-only .MuiTableHead-root .MuiTableRow-root .MuiTableCell-root:first-of-type {
  background-color: #16213e !important;
  color: #e0e0e0 !important;
}
body.dark-only .MuiToolbar-root,
body.dark-only .top-toolbar-wrapper__new,
body.dark-only .bottom-toolbar-wrapper__new,
body.dark-only .table-footer-wrapper__new,
body.dark-only .MuiTableFooter-root,
body.dark-only .MuiTablePagination-root,
body.dark-only .MuiTablePagination-toolbar,
body.dark-only .MuiTableFooter-root .MuiTableCell-root {
  background-color: #16213e !important;
  color: #e0e0e0 !important;
  border-top: 1px solid #2e2e42 !important;
}
body.dark-only .top-toolbar-wrapper__new .MuiBox-root,
body.dark-only .MuiToolbar-root .MuiBox-root {
  background-color: transparent !important;
  color: #e0e0e0 !important;
}
body.dark-only .MuiTablePagination-displayedRows,
body.dark-only .MuiTablePagination-selectLabel,
body.dark-only .MuiTablePagination-select,
body.dark-only .MuiTablePagination-actions,
body.dark-only .MuiTablePagination-root p,
body.dark-only .MuiTablePagination-root span,
body.dark-only .MuiTablePagination-root label {
  color: #e0e0e0 !important;
  -webkit-text-fill-color: #e0e0e0 !important;
}
body.dark-only .MuiTablePagination-select,
body.dark-only .MuiNativeSelect-select,
body.dark-only .MuiInputBase-input {
  background-color: #2a2a3e !important;
  color: #e0e0e0 !important;
  -webkit-text-fill-color: #e0e0e0 !important;
}
body.dark-only .MuiTablePagination-actions .MuiIconButton-root,
body.dark-only .bottom-toolbar-wrapper__new .MuiIconButton-root {
  color: #e5f3ff !important;
}
body.dark-only .MuiTablePagination-actions .MuiIconButton-root.Mui-disabled,
body.dark-only .bottom-toolbar-wrapper__new .MuiIconButton-root.Mui-disabled {
  color: #555 !important;
}
body.dark-only .MuiSelect-icon,
body.dark-only .MuiNativeSelect-icon,
body.dark-only .bottom-toolbar-wrapper__new .MuiSvgIcon-root {
  color: #e0e0e0 !important;
}
body.dark-only .MuiInputBase-root,
body.dark-only .MuiOutlinedInput-root {
  background-color: #2a2a3e !important;
  color: #e0e0e0 !important;
  border-color: #3a3a52 !important;
}
body.dark-only .MuiInputBase-root input, body.dark-only .MuiInputBase-root textarea,
body.dark-only .MuiOutlinedInput-root input,
body.dark-only .MuiOutlinedInput-root textarea {
  color: #e0e0e0 !important;
}
body.dark-only .MuiInputBase-root input::placeholder, body.dark-only .MuiInputBase-root textarea::placeholder,
body.dark-only .MuiOutlinedInput-root input::placeholder,
body.dark-only .MuiOutlinedInput-root textarea::placeholder {
  color: #888 !important;
  opacity: 1;
}
body.dark-only .MuiInputBase-root fieldset,
body.dark-only .MuiOutlinedInput-root fieldset {
  border-color: #3a3a52 !important;
}
body.dark-only .MuiInputBase-root:hover fieldset,
body.dark-only .MuiOutlinedInput-root:hover fieldset {
  border-color: #5a5a7a !important;
}
body.dark-only .MuiInputBase-root.Mui-focused fieldset,
body.dark-only .MuiOutlinedInput-root.Mui-focused fieldset {
  border-color: #009db5 !important;
}
body.dark-only .MuiInputBase-root.MuiInput-root {
  color: #e0e0e0 !important;
}
body.dark-only .MuiInputBase-root.MuiInput-root::before {
  border-bottom-color: #3a3a52 !important;
}
body.dark-only .MuiInputBase-root.MuiInput-root::after {
  border-bottom-color: #009db5 !important;
}
body.dark-only .MuiSelect-select,
body.dark-only .MuiNativeSelect-select {
  background-color: #2a2a3e !important;
  color: #e0e0e0 !important;
}
body.dark-only .MuiMenuItem-root {
  background-color: #1e1e2e !important;
  color: #e0e0e0 !important;
}
body.dark-only .MuiMenuItem-root:hover, body.dark-only .MuiMenuItem-root.Mui-selected, body.dark-only .MuiMenuItem-root.Mui-selected:hover {
  background-color: #2a2a3e !important;
}
body.dark-only .MuiPopover-paper,
body.dark-only .MuiMenu-paper,
body.dark-only .MuiList-root,
body.dark-only .MuiAutocomplete-listbox,
body.dark-only .MuiAutocomplete-paper {
  background-color: #1e1e2e !important;
  color: #e0e0e0 !important;
  border: 1px solid #2e2e42 !important;
}
body.dark-only .MuiListItemText-primary,
body.dark-only .MuiListItemText-secondary {
  color: #e0e0e0 !important;
}
body.dark-only .MuiButton-root {
  color: #e5f3ff !important;
}
body.dark-only .MuiButton-root.MuiButton-contained {
  background-color: #009db5 !important;
  color: #fff !important;
}
body.dark-only .MuiButton-root.MuiButton-outlined {
  border-color: #3a3a52 !important;
  color: #e5f3ff !important;
}
body.dark-only .MuiIconButton-root {
  color: #e0e0e0 !important;
}
body.dark-only .MuiIconButton-root:hover {
  background-color: rgba(255, 255, 255, 0.06) !important;
}
body.dark-only .MuiTableCell-root .MuiIconButton-root {
  color: #e5f3ff !important;
}
body.dark-only .MuiTableCell-root .MuiIconButton-root svg {
  color: #e5f3ff !important;
}
body.dark-only .MuiTableCell-root .MuiIconButton-root[aria-label=Delete],
body.dark-only .MuiTableCell-root .MuiIconButton-root:has(.MuiSvgIcon-colorError) {
  color: #f44336 !important;
}
body.dark-only .MuiTableCell-root .MuiIconButton-root[aria-label=Delete] svg,
body.dark-only .MuiTableCell-root .MuiIconButton-root:has(.MuiSvgIcon-colorError) svg {
  color: #f44336 !important;
}
body.dark-only .MuiCheckbox-root {
  color: #e5f3ff !important;
}
body.dark-only .MuiCheckbox-root.Mui-checked {
  color: #009db5 !important;
}
body.dark-only .MuiSwitch-track {
  background-color: #444 !important;
}
body.dark-only .MuiTypography-root {
  color: #e0e0e0 !important;
}
body.dark-only .MuiDivider-root {
  border-color: #2e2e42 !important;
}
body.dark-only .MuiBadge-badge {
  background-color: #009db5 !important;
  color: #fff !important;
}
body.dark-only .MuiChip-root:not([class*=status-chip]):not([class*=filter-chip]) {
  background-color: #2a2a3e !important;
  color: #e0e0e0 !important;
}
body.dark-only .MuiChip-root:not([class*=status-chip]):not([class*=filter-chip]) .MuiChip-deleteIcon {
  color: #aaa !important;
}
body.dark-only .MuiTooltip-tooltip {
  background-color: #2a2a3e !important;
  color: #e0e0e0 !important;
  border: 1px solid #3a3a52 !important;
}
body.dark-only .MuiTooltip-arrow {
  color: #2a2a3e !important;
}
body.dark-only .MuiLinearProgress-root {
  background-color: #2a2a3e !important;
}
body.dark-only .MuiLinearProgress-root .MuiLinearProgress-bar {
  background-color: #009db5 !important;
}
body.dark-only .MuiCollapse-root {
  background-color: #1e1e2e !important;
}
body.dark-only .MuiSnackbarContent-root {
  background-color: #2a2a3e !important;
  color: #e0e0e0 !important;
}
body.dark-only .Mui-TableHeadCell-ResizeHandle,
body.dark-only [class*=ResizeHandle] {
  background-color: #444 !important;
}
body.dark-only .Mui-TableHeadCell-ResizeHandle:hover,
body.dark-only [class*=ResizeHandle]:hover {
  background-color: #009db5 !important;
}
body.dark-only [class*=DragHandle] {
  color: #666 !important;
}
body.dark-only .MuiTableRow-root.MuiTableRow-head ~ .MuiTableRow-root th {
  background-color: #1a1a2e !important;
}
body.dark-only .MuiTableRow-root[aria-expanded] td {
  background-color: #1a2a3e !important;
  color: #e5f3ff !important;
  font-weight: 600;
}
body.dark-only .MuiDialog-paper,
body.dark-only .MuiDialogContent-root,
body.dark-only .MuiDialogActions-root {
  background-color: #1e1e2e !important;
  color: #e0e0e0 !important;
  border-color: #2e2e42 !important;
}
body.dark-only .MuiDialogTitle-root {
  background-color: #16213e !important;
  color: #e0e0e0 !important;
  border-bottom: 1px solid #2e2e42 !important;
}
body.dark-only .MuiDialogActions-root {
  border-top: 1px solid #2e2e42 !important;
}
body.dark-only pre {
  background-color: #1e1e2e !important;
  color: #e0e0e0 !important;
}
body.dark-only .table-ad__addInputs .accordion-item {
  background-color: #16213e !important;
  border-color: #2e2e42 !important;
}
body.dark-only .table-ad__addInputs .accordion-body {
  background-color: #1e1e2e !important;
  color: #e0e0e0 !important;
}
body.dark-only .table-ad__addInputs .accordion-button,
body.dark-only .table-ad__addInputs .accordion-button:not(.collapsed) {
  background-color: #16213e !important;
  color: #e0e0e0 !important;
  box-shadow: none !important;
}
body.dark-only .table-ad__addInputs .accordion-button::after,
body.dark-only .table-ad__addInputs .accordion-button:not(.collapsed)::after {
  background-color: transparent !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
  background-repeat: no-repeat !important;
  background-size: 1rem !important;
  border: none !important;
  box-shadow: none !important;
}
body.dark-only .table-ad__addInputs .accordion-button:focus,
body.dark-only .table-ad__addInputs .accordion-button:not(.collapsed):focus {
  box-shadow: none !important;
  border-color: transparent !important;
}
body.dark-only .table-container-wrapper__new,
body.dark-only .MuiTableContainer-root {
  scrollbar-color: #3a3a52 #1e1e2e;
  scrollbar-width: thin;
}
body.dark-only .table-container-wrapper__new::-webkit-scrollbar,
body.dark-only .MuiTableContainer-root::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
body.dark-only .table-container-wrapper__new::-webkit-scrollbar-track,
body.dark-only .MuiTableContainer-root::-webkit-scrollbar-track {
  background: #1e1e2e !important;
  border-radius: 4px;
}
body.dark-only .table-container-wrapper__new::-webkit-scrollbar-thumb,
body.dark-only .MuiTableContainer-root::-webkit-scrollbar-thumb {
  background-color: #3a3a52 !important;
  border-radius: 4px;
  border: 2px solid #1e1e2e;
}
body.dark-only .table-container-wrapper__new::-webkit-scrollbar-thumb:hover,
body.dark-only .MuiTableContainer-root::-webkit-scrollbar-thumb:hover {
  background-color: #5a5a7a !important;
}
body.dark-only .table-container-wrapper__new::-webkit-scrollbar-thumb:active,
body.dark-only .MuiTableContainer-root::-webkit-scrollbar-thumb:active {
  background-color: #009db5 !important;
}
body.dark-only .table-container-wrapper__new::-webkit-scrollbar-corner,
body.dark-only .MuiTableContainer-root::-webkit-scrollbar-corner {
  background: #1e1e2e !important;
}
body.dark-only ::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
body.dark-only ::-webkit-scrollbar-track {
  background: #1e1e2e;
}
body.dark-only ::-webkit-scrollbar-thumb {
  background: #3a3a52;
  border-radius: 3px;
}
body.dark-only ::-webkit-scrollbar-thumb:hover {
  background: #5a5a7a;
}
body.dark-only .trading-wrapper {
  background: linear-gradient(to right, #4a0db5, #4f2d8a);
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.4);
}
body.dark-only .trading-wrapper > div {
  background-color: #1e1e2e;
  color: #e0e0e0;
}
body.dark-only .trading-header h5 {
  color: #e0e0e0;
}
body.dark-only .text-dark {
  color: #e0e0e0 !important;
}
body.dark-only .MuiTab-root {
  color: #888 !important;
  border: 1px solid #3a3a52 !important;
  border-radius: 4px;
}
body.dark-only .MuiTab-root.Mui-selected {
  background-color: #2a2a3e !important;
  color: #009db5 !important;
  border-radius: 4px;
  border: 1px solid #009db5 !important;
}
body.dark-only .MuiTabs-indicator {
  background-color: #009db5 !important;
  display: block !important;
}
body.dark-only .form_default {
  background-color: #1e1e2e !important;
  color: #e0e0e0 !important;
  border-color: #2e2e42 !important;
}`, "",{"version":3,"sources":["webpack://./src/scss/_darkmode.scss"],"names":[],"mappings":"AAsBA;EACE,oCAAA;AArBF;AAuBE;;;EAGE,oCAAA;AArBJ;AAwBE;EACE,oCAAA;EACA,kBAAA;EACA,oCAAA;AAtBJ;AA0BE;;;;;;;;;;;EAWE,oCAAA;EACA,yBAAA;AAxBJ;AA2BA;EACE,wCAAA;EACA,yBAAA;AAzBF;AA4BE;EACG,oCAAA;AA1BL;AA8BE;;;;EAIE,oCAAA;EACA,yBAAA;EACA,2CAAA;AA5BJ;AAiCI;;;;EAIE,yBAAA;EACA,wBAAA;EACA,uBAAA;AA/BN;AAkCI;EACE,qBAAA;EACA,yBAAA;EACA,wBAAA;AAhCN;AAqCE;;;;EAIE,oCAAA;EACA,sBAAA;EACA,2CAAA;AAnCJ;AAsCE;EACE,oCAAA;AApCJ;AAuCE;;EAEE,oCAAA;EACA,eAAA;AArCJ;AAyCE;;EAEE,oCAAA;EACA,yBAAA;EACA,2BAAA;AAvCJ;AA0CE;;EAEE,kCAAA;EACA,2BAAA;AAxCJ;AA2CE;EACE,oCAAA;EACA,yBAAA;AAzCJ;AA6CE;;;;;;;;EAQE,oCAAA;EACA,yBAAA;EACA,wCAAA;AA3CJ;AA8CE;;EAEE,wCAAA;EACA,yBAAA;AA5CJ;AAgDE;;;;;;;EAOE,yBAAA;EACA,2CAAA;AA9CJ;AAiDE;;;EAGE,oCAAA;EACA,yBAAA;EACA,2CAAA;AA/CJ;AAkDE;;EAEE,yBAAA;AAhDJ;AAiDI;;EAAiB,sBAAA;AA7CrB;AAgDE;;;EAGE,yBAAA;AA9CJ;AAkDE;;EAEE,oCAAA;EACA,yBAAA;EACA,gCAAA;AAhDJ;AAkDI;;;EACE,yBAAA;AA9CN;AA+CM;;;EAAiB,sBAAA;EAA+B,UAAA;AAzCtD;AA4CI;;EAAW,gCAAA;AAxCf;AAyCI;;EAAmB,gCAAA;AArCvB;AAsCI;;EAAyB,gCAAA;AAlC7B;AAqCE;EACE,yBAAA;AAnCJ;AAoCI;EAAY,uCAAA;AAjChB;AAkCI;EAAY,uCAAA;AA/BhB;AAmCE;;EAEE,oCAAA;EACA,yBAAA;AAjCJ;AAoCE;EACE,oCAAA;EACA,yBAAA;AAlCJ;AAmCI;EACE,oCAAA;AAjCN;AAsCE;;;;;EAKE,oCAAA;EACA,yBAAA;EACA,oCAAA;AApCJ;AAuCE;;EAC6B,yBAAA;AApC/B;AAuCE;EACE,yBAAA;AArCJ;AAsCI;EAAwB,oCAAA;EAAsC,sBAAA;AAlClE;AAmCI;EAAwB,gCAAA;EAAsC,yBAAA;AA/BlE;AAkCE;EACE,yBAAA;AAhCJ;AAiCI;EAAU,sDAAA;AA9Bd;AAiCE;EACE,yBAAA;AA/BJ;AAgCI;EAAM,yBAAA;AA7BV;AAgCE;;EAEE,yBAAA;AA9BJ;AA+BI;;EAAM,yBAAA;AA3BV;AA+BE;EACE,yBAAA;AA7BJ;AA8BI;EAAgB,yBAAA;AA3BpB;AA8BE;EAAmB,iCAAA;AA3BrB;AA8BE;EAAwB,yBAAA;AA3B1B;AA4BE;EAAwB,gCAAA;AAzB1B;AA0BE;EAAwB,oCAAA;EAAsC,sBAAA;AAtBhE;AAuBE;EACC,oCAAA;EACA,yBAAA;AArBH;AAsBE;EAAsB,sBAAA;AAnBxB;AAqBE;EAAwB,oCAAA;EAAwC,yBAAA;EACxC,oCAAA;AAjB1B;AAkBE;EAAwB,yBAAA;AAf1B;AAgBE;EAA0B,oCAAA;AAb5B;AAc4B;EAAyB,oCAAA;AAXrD;AAYE;EAAwB,oCAAA;AAT1B;AAUE;EAA2B,oCAAA;EAAwC,yBAAA;AANrE;AASE;;EAEE,iCAAA;AAPJ;AAQI;;EAAU,oCAAA;AAJd;AAOE;EAAwB,sBAAA;AAJ1B;AAOE;EACE,oCAAA;AALJ;AASE;EACE,oCAAA;EACA,yBAAA;EACA,gBAAA;AAPJ;AAWE;;;EAEyB,oCAAA;EAAuC,yBAAA;EAAyB,gCAAA;AAN3F;AAOE;EAAyB,oCAAA;EAAuC,yBAAA;EAAyB,2CAAA;AAF3F;AAGE;EAAyB,wCAAA;AAA3B;AAGE;EAAM,oCAAA;EAAuC,yBAAA;AAC/C;AAGI;EAAkB,oCAAA;EAAuC,gCAAA;AAC7D;AAAI;EAAmB,oCAAA;EAAuC,yBAAA;AAI9D;AAFI;;EAEE,oCAAA;EACA,yBAAA;EACA,2BAAA;AAIN;AAFM;;EACE,wCAAA;EACA,oEAAA;EACA,uCAAA;EACA,gCAAA;EACA,uBAAA;EACA,2BAAA;AAKR;AAFM;;EAAU,2BAAA;EAA6B,oCAAA;AAO7C;AAFE;;EAEE,gCAAA;EACA,qBAAA;AAIJ;AAFI;;EAA6B,UAAA;EAAY,WAAA;AAO7C;AANI;;EAA6B,8BAAA;EAAiC,kBAAA;AAWlE;AAVI;;EAA6B,oCAAA;EAA0C,kBAAA;EACzC,yBAAA;AAelC;AAdkC;;EAAW,oCAAA;AAkB7C;AAjBkC;;EAAW,oCAAA;AAqB7C;AApBI;;EAA8B,8BAAA;AAwBlC;AApBE;EAA4B,UAAA;EAAY,WAAA;AAwB1C;AAvBE;EAA4B,mBA7VhB;AAuXd;AAzBE;EAA4B,mBAzVhB;EAyVyC,kBAAA;AA6BvD;AA5B+B;EAAU,mBAzV3B;AAwXd;AA7BI;EACA,uDAAA;EACA,uCAAA;AA+BJ;AA7BI;EACE,yBAtWQ;EAuWR,cAhWQ;AA+Xd;AA3BE;EAAqB,cApWT;AAkYd;AA7BE;EACE,yBAAA;AA+BJ;AA3BE;EACE,sBAAA;EACA,oCAAA;EACA,kBAAA;AA6BJ;AA5BI;EACE,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,oCAAA;AA8BN;AA1BE;EACE,oCAAA;EACA,yBAAA;AA4BJ;AAxBE;EACE,oCAAA;EACA,yBAAA;EACA,gCAAA;AA0BJ","sourcesContent":["\n\n// ── Shared color tokens ──────────────────────────────────────\n$bg-deep:     #16213e;\n$bg-base:     #1e1e2e;\n$bg-dark:     #1a1a2e;\n$bg-elevated: #22223a;\n$bg-input:    #2a2a3e;\n$border:      #2e2e42;\n$border-mid:  #3a3a52;\n$border-hi:   #5a5a7a;\n$text:        #e0e0e0;\n$text-dim:    #ccc;\n$text-muted:  #888;\n$text-disabled:#555;\n$accent:      #009db5;\n$accent-light:#e5f3ff;\n$danger:      #f44336;\n\n// ── Reusable chevron SVG (white) ─────────────────────────────\n$chevron-white: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23e0e0e0'%3E%3Cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E\");\n\nbody.dark-only {\n  background-color: $bg-base !important;\n\n  .page-body-wrapper,\n  .page-body,\n  .container-fluid {\n    background-color: $bg-base !important;\n  }\n\n  .table-ad {\n    border: 1px solid $accent !important; \n    border-radius: 4px;\n    background-color: $bg-base !important;\n  }\n\n  // ── Paper / containers ──────────────────────────────────────\n  .MuiPaper-root,\n  .MuiDialog-paper,\n  .MuiTableContainer-root,\n  .MuiTable-root,\n  .MuiPaper-elevation,\n  .MuiPaper-rounded,\n  .MuiPaper-elevation2,\n  .table-ad,\n  .table-ad__wrapper,\n  .table-ad__wrapperCard,\n  .tablePaperPosition {\n    background-color: $bg-base !important;\n    color: $text !important;\n  }\n\n.table-ad__wrapperCard .table-ad__bg-reset {\n  background-color: transparent !important;\n  color: $text !important;\n}\n\n  .table-ad__wrapperCard {\n     border: 1px solid $accent !important; \n  }\n  \n  // ── Table head ───────────────────────────────────────────────\n  .MuiTableHead-root .MuiTableCell-root,\n  .MuiTableHead-root th,\n  .MuiTableCell-stickyHeader,\n  .MuiTableHead-root th[data-pinned=\"true\"] {\n    background-color: $bg-deep !important;\n    color: $text !important;\n    border-bottom: 1px solid $border !important;\n  }\n\n  // ── Sort icons ───────────────────────────────────────────────\n  .MuiTableHead-root {\n    .MuiTableSortLabel-icon,\n    .MuiTableSortLabel-root svg,\n    .Mui-TableHeadCell-Content-Actions svg,\n    .Mui-TableHeadCell-Content-Labels svg {\n      color: $text !important;\n      fill: $text !important;\n      opacity: 0.4 !important;\n    }\n\n    .MuiTableSortLabel-root.Mui-active .MuiTableSortLabel-icon {\n      opacity: 1 !important;\n      color: $accent !important;\n      fill: $accent !important;\n    }\n  }\n\n  // ── Table body ───────────────────────────────────────────────\n  .MuiTableBody-root .MuiTableCell-root,\n  .MuiTableBody-root td,\n  td[data-pinned=\"true\"],\n  .MuiTableBody-root .MuiTableRow-root .MuiTableCell-root:first-of-type {\n    background-color: $bg-base !important;\n    color: $text-dim !important;\n    border-bottom: 1px solid $border !important;\n  }\n\n  .MuiTableBody-root .MuiTableRow-root:nth-of-type(even) td {\n    background-color: $bg-elevated !important;\n  }\n\n  .MuiTableRow-root:hover td,\n  .MuiTableBody-root .MuiTableRow-root:hover .MuiTableCell-root {\n    background-color: $bg-input !important;\n    cursor: pointer;\n  }\n\n  // ── Pinned column cleanup ────────────────────────────────────\n  th[data-pinned=\"true\"],\n  .MuiTableCell-root[data-pinned=\"true\"] {\n    background-color: $bg-base !important;\n    color: $text !important;\n    box-shadow: none !important;\n  }\n\n  td[data-pinned=\"true\"]::after, td[data-pinned=\"true\"]::before,\n  th[data-pinned=\"true\"]::after, th[data-pinned=\"true\"]::before {\n    background: transparent !important;\n    box-shadow: none !important;\n  }\n\n  .MuiTableHead-root .MuiTableRow-root .MuiTableCell-root:first-of-type {\n    background-color: $bg-deep !important;\n    color: $text !important;\n  }\n\n  // ── Toolbars ─────────────────────────────────────────────────\n  .MuiToolbar-root,\n  .top-toolbar-wrapper__new,\n  .bottom-toolbar-wrapper__new,\n  .table-footer-wrapper__new,\n  .MuiTableFooter-root,\n  .MuiTablePagination-root,\n  .MuiTablePagination-toolbar,\n  .MuiTableFooter-root .MuiTableCell-root {\n    background-color: $bg-deep !important;\n    color: $text !important;\n    border-top: 1px solid $border !important;\n  }\n\n  .top-toolbar-wrapper__new .MuiBox-root,\n  .MuiToolbar-root .MuiBox-root {\n    background-color: transparent !important;\n    color: $text !important;\n  }\n\n  // ── Pagination ───────────────────────────────────────────────\n  .MuiTablePagination-displayedRows,\n  .MuiTablePagination-selectLabel,\n  .MuiTablePagination-select,\n  .MuiTablePagination-actions,\n  .MuiTablePagination-root p,\n  .MuiTablePagination-root span,\n  .MuiTablePagination-root label {\n    color: $text !important;\n    -webkit-text-fill-color: $text !important;\n  }\n\n  .MuiTablePagination-select,\n  .MuiNativeSelect-select,\n  .MuiInputBase-input {\n    background-color: $bg-input !important;\n    color: $text !important;\n    -webkit-text-fill-color: $text !important;\n  }\n\n  .MuiTablePagination-actions .MuiIconButton-root,\n  .bottom-toolbar-wrapper__new .MuiIconButton-root {\n    color: $accent-light !important;\n    &.Mui-disabled { color: $text-disabled !important; }\n  }\n\n  .MuiSelect-icon,\n  .MuiNativeSelect-icon,\n  .bottom-toolbar-wrapper__new .MuiSvgIcon-root {\n    color: $text !important;\n  }\n\n  // ── Inputs ───────────────────────────────────────────────────\n  .MuiInputBase-root,\n  .MuiOutlinedInput-root {\n    background-color: $bg-input !important;\n    color: $text !important;\n    border-color: $border-mid !important;\n\n    input, textarea {\n      color: $text !important;\n      &::placeholder { color: $text-muted !important; opacity: 1; }\n    }\n\n    fieldset { border-color: $border-mid !important; }\n    &:hover fieldset { border-color: $border-hi !important; }\n    &.Mui-focused fieldset { border-color: $accent !important; }\n  }\n\n  .MuiInputBase-root.MuiInput-root {\n    color: $text !important;\n    &::before { border-bottom-color: $border-mid !important; }\n    &::after  { border-bottom-color: $accent !important; }\n  }\n\n  // ── Selects / Dropdowns ──────────────────────────────────────\n  .MuiSelect-select,\n  .MuiNativeSelect-select {\n    background-color: $bg-input !important;\n    color: $text !important;\n  }\n\n  .MuiMenuItem-root {\n    background-color: $bg-base !important;\n    color: $text !important;\n    &:hover, &.Mui-selected, &.Mui-selected:hover {\n      background-color: $bg-input !important;\n    }\n  }\n\n  // ── Popovers / Menus ─────────────────────────────────────────\n  .MuiPopover-paper,\n  .MuiMenu-paper,\n  .MuiList-root,\n  .MuiAutocomplete-listbox,\n  .MuiAutocomplete-paper {\n    background-color: $bg-base !important;\n    color: $text !important;\n    border: 1px solid $border !important;\n  }\n\n  .MuiListItemText-primary,\n  .MuiListItemText-secondary { color: $text !important; }\n\n  // ── Buttons ──────────────────────────────────────────────────\n  .MuiButton-root {\n    color: $accent-light !important;\n    &.MuiButton-contained { background-color: $accent !important; color: #fff !important; }\n    &.MuiButton-outlined  { border-color: $border-mid !important; color: $accent-light !important; }\n  }\n\n  .MuiIconButton-root {\n    color: $text !important;\n    &:hover { background-color: rgba(255,255,255,0.06) !important; }\n  }\n\n  .MuiTableCell-root .MuiIconButton-root {\n    color: $accent-light !important;\n    svg { color: $accent-light !important; }\n  }\n\n  .MuiTableCell-root .MuiIconButton-root[aria-label=\"Delete\"],\n  .MuiTableCell-root .MuiIconButton-root:has(.MuiSvgIcon-colorError) {\n    color: $danger !important;\n    svg { color: $danger !important; }\n  }\n\n  // ── Checkbox / Switch ────────────────────────────────────────\n  .MuiCheckbox-root {\n    color: $accent-light !important;\n    &.Mui-checked { color: $accent !important; }\n  }\n\n  .MuiSwitch-track { background-color: #444 !important; }\n\n  // ── Misc MUI ─────────────────────────────────────────────────\n  .MuiTypography-root   { color: $text !important; }\n  .MuiDivider-root      { border-color: $border !important; }\n  .MuiBadge-badge       { background-color: $accent !important; color: #fff !important; }\n  .MuiChip-root:not([class*=\"status-chip\"]):not([class*=\"filter-chip\"]) {\n   background-color: $bg-input !important;\n   color: $text !important;\n  .MuiChip-deleteIcon { color: #aaa !important; }\n}\n  .MuiTooltip-tooltip   { background-color: $bg-input !important; color: $text !important;\n                          border: 1px solid $border-mid !important; }\n  .MuiTooltip-arrow     { color: $bg-input !important; }\n  .MuiLinearProgress-root { background-color: $bg-input !important;\n                            .MuiLinearProgress-bar { background-color: $accent !important; } }\n  .MuiCollapse-root     { background-color: $bg-base !important; }\n  .MuiSnackbarContent-root { background-color: $bg-input !important; color: $text !important; }\n\n  // ── Column handles ───────────────────────────────────────────\n  .Mui-TableHeadCell-ResizeHandle,\n  [class*=\"ResizeHandle\"] {\n    background-color: #444 !important;\n    &:hover { background-color: $accent !important; }\n  }\n\n  [class*=\"DragHandle\"] { color: #666 !important; }\n\n  // ── Filter row ───────────────────────────────────────────────\n  .MuiTableRow-root.MuiTableRow-head ~ .MuiTableRow-root th {\n    background-color: $bg-dark !important;\n  }\n\n  // ── Grouped rows ─────────────────────────────────────────────\n  .MuiTableRow-root[aria-expanded] td {\n    background-color: #1a2a3e !important;\n    color: $accent-light !important;\n    font-weight: 600;\n  }\n\n  // ── Dialog ───────────────────────────────────────────────────\n  .MuiDialog-paper,\n  .MuiDialogContent-root,\n  .MuiDialogActions-root { background-color: $bg-base !important; color: $text !important; border-color: $border !important; }\n  .MuiDialogTitle-root   { background-color: $bg-deep !important; color: $text !important; border-bottom: 1px solid $border !important; }\n  .MuiDialogActions-root { border-top: 1px solid $border !important; }\n\n  // ── Pre / logs ───────────────────────────────────────────────\n  pre { background-color: $bg-base !important; color: $text !important; }\n\n  // ── Accordion ────────────────────────────────────────────────\n  .table-ad__addInputs {\n    .accordion-item { background-color: $bg-deep !important; border-color: $border !important; }\n    .accordion-body  { background-color: $bg-base !important; color: $text !important; }\n\n    .accordion-button,\n    .accordion-button:not(.collapsed) {\n      background-color: $bg-deep !important;\n      color: $text !important;\n      box-shadow: none !important;\n\n      &::after {\n        background-color: transparent !important;\n        background-image: $chevron-white !important;\n        background-repeat: no-repeat !important;\n        background-size: 1rem !important;\n        border: none !important;\n        box-shadow: none !important;\n      }\n\n      &:focus { box-shadow: none !important; border-color: transparent !important; }\n    }\n  }\n\n  // ── Scrollbar ────────────────────────────────────────────────\n  .table-container-wrapper__new,\n  .MuiTableContainer-root {\n    scrollbar-color: $border-mid $bg-base;\n    scrollbar-width: thin;\n\n    &::-webkit-scrollbar       { width: 8px; height: 8px; }\n    &::-webkit-scrollbar-track { background: $bg-base !important; border-radius: 4px; }\n    &::-webkit-scrollbar-thumb { background-color: $border-mid !important; border-radius: 4px;\n                                  border: 2px solid $bg-base;\n                                  &:hover  { background-color: $border-hi !important; }\n                                  &:active { background-color: $accent !important; } }\n    &::-webkit-scrollbar-corner { background: $bg-base !important; }\n  }\n\n  // Global fallback scrollbar\n  ::-webkit-scrollbar       { width: 6px; height: 6px; }\n  ::-webkit-scrollbar-track { background: $bg-base; }\n  ::-webkit-scrollbar-thumb { background: $border-mid; border-radius: 3px;\n                               &:hover { background: $border-hi; } }\n\n    .trading-wrapper {\n    background: linear-gradient(to right, #4a0db5, #4f2d8a);\n    box-shadow: 0 0 12px rgba(0, 0, 0, 0.4);\n\n    & > div {\n      background-color: $bg-base;\n      color: $text;\n    }\n  }\n\n  .trading-header h5 { color: $text; }   \n  .text-dark {\n    color: $text !important;\n  }    \n  \n  // ── Tabs ─────────────────────────────────────────────────────\n  .MuiTab-root {\n    color: $text-muted !important;\n    border: 1px solid $border-mid !important;\n    border-radius: 4px;\n    &.Mui-selected {\n      background-color: $bg-input !important;\n      color: $accent !important;\n      border-radius: 4px;\n      border: 1px solid $accent !important;\n    }\n  }\n\n  .MuiTabs-indicator {\n    background-color: $accent !important;\n    display: block !important; \n  }\n\n  // ── Form default ─────────────────────────────────────────────\n  .form_default {\n    background-color: $bg-base !important;\n    color: $text !important;\n    border-color: $border !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
